export const API_BASE_URL =
   process.env.REACT_APP_API_BASE_URL || 'https://epaapi.apphub.co.in';
  // Local: use HTTP so Activity History <img> tags are not blocked by self-signed HTTPS cert.
  //process.env.REACT_APP_API_BASE_URL || 'http://localhost:5078';
  //process.env.REACT_APP_API_BASE_URL || 'https://localhost:7121';


export const COMPANY_NAME =
  process.env.REACT_APP_COMPANY_NAME || 'EPA';

// Set true to show priority on task cards and in the card modal.
export const SHOW_CARD_PRIORITY = false;

// Set true to show the Teams filter dropdown on Tasks and Productivity Reports pages.
export const SHOW_TEAMS_FILTER = false;

// Set true to show recursive task fields in the task card modal.
export const SHOW_RECURSIVE_TASK = false;

